export default "../../src/img/app-store-swedish.svg";